import { render, staticRenderFns } from "./TheOrganisation.vue?vue&type=template&id=79893fca&scoped=true&"
import script from "./TheOrganisation.vue?vue&type=script&lang=js&"
export * from "./TheOrganisation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79893fca",
  null
  
)

export default component.exports